import {Component, input, InputSignal} from '@angular/core';

import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-icon-button',
  standalone: true,
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
})
export class IconButtonComponent {
  readonly icon: InputSignal<SvgSpriteIcon> = input.required<SvgSpriteIcon>();
  readonly label: InputSignal<string | undefined> = input<string>();
}
